import { ContentHubLayout } from "@/components/content/ContentHubLayout";
import { INTERCITY_HUB } from "@/data/content/contentHubs";

export default function IntercityHubPage() {
  return (
    <ContentHubLayout
      eyebrow={INTERCITY_HUB.eyebrow}
      title={INTERCITY_HUB.title}
      overview={INTERCITY_HUB.overview}
      sections={INTERCITY_HUB.sections}
      relatedHubs={INTERCITY_HUB.relatedHubs}
    />
  );
}
